import { Alert, VFlow } from 'bold-ui'
import { ClassificacaoVulnerabilidadeFamiliar, GrauSugestivoVulnerabilidadeFamiliar } from 'graphql/types.generated'

import { VulnerabilidadeFamiliarStatus } from './VulnerabilidadeFamiliarStatus'

interface VulnerabilidadeFamiliarResultProps {
  classificacao: ClassificacaoVulnerabilidadeFamiliar
  escore?: number | null
  grauSugestivo?: GrauSugestivoVulnerabilidadeFamiliar | null
  classificacaoSubestimada?: boolean | null
}

export const VulnerabilidadeFamiliarResult = ({
  classificacao,
  escore,
  grauSugestivo,
  classificacaoSubestimada,
}: Readonly<VulnerabilidadeFamiliarResultProps>) => {
  return (
    <VFlow vSpacing={0.5}>
      <VulnerabilidadeFamiliarStatus classificacao={classificacao} grauSugestivo={grauSugestivo} escore={escore} />
      {classificacaoSubestimada && (
        <Alert type='warning'>
          Atenção! Existe um ou mais cadastros incompletos ou ausência de prontuário que podem ter subestimado a
          classificação de vulnerabilidade dessa família.
        </Alert>
      )}
    </VFlow>
  )
}
